import {
  VehicleInfoLookup,
  VehicleModelTrimLookup,
  VehicleType,
  VinWarrantyExpiry
} from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

export class VehicleApi {
  async getRegisteredVehicles(
    vrn: string,
    token: string,
    successCallback: (vehicle: VehicleType) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): Promise<void> {
    const dataUrl = `/api/vehicle/vehicle?vrn=${vrn}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  async getRegisteredVehiclesVin(
    vin: string,
    token: string,
    successCallback: (vehicle: VehicleType) => void,
    failureCallback: () => void,
    signal: AbortSignal,
    considerRegistrationDate: boolean = true
  ): Promise<void> {
    const dataUrl = `/api/vehicle/vehicle/vin?vin=${vin}&considerRegistrationDate=${considerRegistrationDate}`;

    await new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  getVehicleTypes(
    countryCode: string | undefined | null,
    firstRegistrationDate: string | undefined | null,
    token: string,
    successCallback: (vehicleTypes: VehicleInfoLookup[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `/api/vehicle/vehicleTypes/${countryCode}/${firstRegistrationDate}`;
    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  getVehicleMakes(
    firstRegistrationDate: string | undefined | null,
    vehicleTypeId: string,
    token: string,
    successCallback: (vehicleMakes: VehicleInfoLookup[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `/api/vehicle/vehicle/${firstRegistrationDate}/${vehicleTypeId}`;
    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  getVehicleModels(
    firstRegistrationDate: string | undefined | null,
    vehicleTypeId: string,
    vehicleMakeId: string,
    token: string,
    successCallback: (vehicleModels: VehicleInfoLookup[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `/api/vehicle/vehicle/${firstRegistrationDate}/${vehicleTypeId}/${vehicleMakeId}`;
    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  getFuelTypes(
    countryCode: string | undefined | null,
    firstRegistrationDate: string | undefined | null,
    vehicleTypeId: string,
    vehicleMakeId: string,
    vehicleModelId: string,
    token: string,
    successCallback: (vehicleTypes: VehicleInfoLookup[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `/api/vehicle/vehicleFuelTypes/${countryCode}/${firstRegistrationDate}/${vehicleTypeId}/${vehicleMakeId}/${vehicleModelId}`;
    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  getEngineSizes(
    firstRegistrationDate: string | undefined | null,
    vehicleTypeId: string,
    vehicleMakeId: string,
    vehicleModelId: string,
    fuelTypeId: string,
    token: string,
    successCallback: (vehicleTypes: VehicleInfoLookup[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `/api/vehicle/vehicle/${firstRegistrationDate}/${vehicleTypeId}/${vehicleMakeId}/${vehicleModelId}/${fuelTypeId}`;
    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  getModelTrims(
    firstRegistrationDate: string | undefined | null,
    vehicleTypeId: string,
    vehicleMakeId: string,
    vehicleModelId: string,
    fuelTypeId: string,
    engineSize: string,
    token: string,
    successCallback: (vehicleTypes: VehicleModelTrimLookup[]) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `/api/vehicle/vehicle/${firstRegistrationDate}/${vehicleTypeId}/${vehicleMakeId}/${vehicleModelId}/${fuelTypeId}/${engineSize}`;

    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  getVinWarrantyExpiry(
    vin: string,
    token: string,
    successCallback: (response: VinWarrantyExpiry) => void,
    failureCallback: (error: string) => void,
    signal: AbortSignal
  ): void {
    const dataUrl = `/api/vehicle/vehicle/vinwarrantyexpiry?vin=${vin}`;
    new ApiHelper().getDataSecureAsync(
      dataUrl,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
